import styled from 'styled-components';

export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.onColor};
  padding: 10px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s ease;
  
  &:hover {
    background-color: ${props => props.theme.colors.primaryHover};
  }

  svg {
    font-size: 18px;
  }
`;
